"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryDatabaseOwnDataQualityWarnings = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var DatabaseLineageUpstreamDataQualityWarningsQueryGql_1 = require("../../queries/DatabaseLineageUpstreamDataQualityWarningsQueryGql");
var renderQueryResult_1 = require("../renderQueryResult");
var DataQualityWarningCycleTemporaryFix_1 = require("./DataQualityWarningCycleTemporaryFix");
function QueryDatabaseOwnDataQualityWarnings(props) {
    var dqcertificationVisualDesignEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).dqcertificationVisualDesignEnabled;
    var urls = React.useContext(data_catalog_shared_1.SiteUrlsContext);
    var renderers = React.useMemo(function () { return dqcertificationVisualDesignEnabled ?
        { renderData: renderWarnings(urls) } :
        { renderData: renderLegacyWarnings(urls) }; }, [dqcertificationVisualDesignEnabled, urls]);
    return (React.createElement(react_apollo_1.Query, { query: DatabaseLineageUpstreamDataQualityWarningsQueryGql_1.DatabaseLineageUpstreamDataQualityWarningsQueryGql, variables: { databaseId: props.nodeId, first: 10, offset: 0 } }, function (result) { return renderQueryResult_1.renderQueryResult(result, renderers); }));
}
exports.QueryDatabaseOwnDataQualityWarnings = QueryDatabaseOwnDataQualityWarnings;
function renderWarnings(urls) {
    return function (data) {
        var _a, _b;
        var database = data.databases && data.databases[0] ? data.databases[0] : null;
        if (!database) {
            return null;
        }
        var props = {
            subjectArea: database.__typename,
            kind: 'graph',
            anchoredAsset: { __typename: 'DataQualityWarning', asset: __assign({}, database) },
            anchoredWarnings: database.dataQualityWarnings,
            iconOnly: false,
            urls: urls,
            upstreamWarnings: DataQualityWarningCycleTemporaryFix_1.filterOutWarningsFromAnchorUntilCycleIsFixed(database.id, (_b = (_a = database.upstreamDataQualityWarningsConnection) === null || _a === void 0 ? void 0 : _a.nodes) !== null && _b !== void 0 ? _b : DataQualityWarningCycleTemporaryFix_1.emptyWarnings)
        };
        return React.createElement(data_catalog_shared_1.WarningStatusChip, __assign({}, props));
    };
}
function renderLegacyWarnings(urls) {
    return function (data) {
        var _a, _b;
        var database = data.databases && data.databases[0] ? data.databases[0] : null;
        if (!database) {
            return null;
        }
        var props = {
            urls: urls,
            iconOnly: false,
            anchoredDataQualityWarnings: database.dataQualityWarnings,
            upstreamDataQualityWarnings: DataQualityWarningCycleTemporaryFix_1.filterOutWarningsFromAnchorUntilCycleIsFixed(database.id, (_b = (_a = database.upstreamDataQualityWarningsConnection) === null || _a === void 0 ? void 0 : _a.nodes) !== null && _b !== void 0 ? _b : DataQualityWarningCycleTemporaryFix_1.emptyWarnings)
        };
        return React.createElement(data_catalog_shared_1.RenderWarningsFromGraph, __assign({}, props));
    };
}
//# sourceMappingURL=DataQualityWarningDatabases.js.map